module.exports = __webpack_public_path__ + "img/clubcard-loyalty-bg-barcord.eac71def.svg";